import type { StaffLeaveStatus } from '../types/hrmsLeaveRequests.types'

interface LeaveStatusPillProps {
  status: StaffLeaveStatus
}

export function LeaveStatusPill({ status }: LeaveStatusPillProps) {
  switch (status) {
    case 'Pending':
      return (
        <span className="inline-flex items-center gap-1.5 rounded-full bg-amber-50 px-2.5 py-1 text-xs font-semibold text-amber-700 border border-amber-200 whitespace-nowrap">
          <span className="h-1.5 w-1.5 rounded-full bg-amber-500 shrink-0" />
          Pending
        </span>
      )
    case 'Approved':
      return (
        <span className="inline-flex items-center gap-1.5 rounded-full bg-emerald-50 px-2.5 py-1 text-xs font-semibold text-emerald-700 border border-emerald-200 whitespace-nowrap">
          <span className="h-1.5 w-1.5 rounded-full bg-emerald-500 shrink-0" />
          Approved
        </span>
      )
    case 'Rejected':
      return (
        <span className="inline-flex items-center gap-1.5 rounded-full bg-red-50 px-2.5 py-1 text-xs font-semibold text-red-700 border border-red-200 whitespace-nowrap">
          <span className="h-1.5 w-1.5 rounded-full bg-red-500 shrink-0" />
          Rejected
        </span>
      )
    default:
      return null
  }
}
